/**
 * FormUtils
 * Utility objects for validating redux-form PropTypes
 *
 * @module lib/FormUtils
 */

import PropTypes from 'prop-types';

export const FormPropShapes = {
  string: {
    initialValue: PropTypes.string.isRequired,
    value: PropTypes.string,
  },
  bool: {
    initialValue: PropTypes.bool.isRequired,
    value: PropTypes.bool,
  },
  number: {
    initialValue: PropTypes.number.isRequired,
    value: PropTypes.number,
  },
};

// parent method is UNUSED
export function shouldInputShowError(x: HTMLFormElement, extraValidation = true): boolean {
  return !x.active && x.touched && x.error && extraValidation;
}
